import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { InquiryService } from '../../../services/inquiry.service';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material.module';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { LabelChipComponent } from '../../label-chip/label-chip.component';
import { FileUtilsService } from '../../../services/file-utils.service';
import { UserService } from '../../../services/user.service';
import { AbstractInquiryDetailComponent } from '../../abstract-inquiry-detail.component';
import { formatAmount, formatDate } from '../../../misc/functions';

@Component({
  selector: 'app-withdrawal-detail',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    LabelChipComponent
  ],
  templateUrl: './withdrawal-detail.component.html',
  styleUrls: ['./withdrawal-detail.component.scss']
})
export class WithdrawalDetailComponent extends AbstractInquiryDetailComponent implements OnInit {

  formatDate = formatDate;
  formatAmount = formatAmount;

  constructor(
    route: ActivatedRoute,
    inquiryService: InquiryService,
    fb: FormBuilder,
    snackBar: ModalSnackbarService,
    fileUtils: FileUtilsService,
    userService: UserService
  ) {
    super(route, inquiryService, fb, snackBar, fileUtils, userService);
  }

}

